module.exports = __webpack_public_path__ + "img/2KG.41d83d30.jpg";